import incentiveBanner from './incentive-banner';

export default incentiveBanner;
